import React from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'state'
import { Flex } from '@nominex/dex-uikit'
import CupertinoPanel from 'components/CupertinoPanel/CupertinoPanel'
import RewardsCardBody, { RewardsCardBodyProps } from 'components/Menu/ExtraRewardsDropdown/RewardsCardBody'
import RewardsCardFooter, { RewardsCardFooterProps } from 'components/Menu/ExtraRewardsDropdown/RewardsCardFooter'

const ExtraRewardsPanel: React.FC<{ openPanel: boolean; onClosed: () => void }> = ({ openPanel, onClosed }) => {
  const {
    fetchStatus: bonusesFetchStatus,
    cashback,
    holderBonus,
    referralFarming,
    referralTrading,
    teamFarming,
    teamTrading,
    total,
  } = useSelector((state: AppState) => state.affiliate.user.bonuses)
  const { fetchStatus: nextRewardFetchStatus, total: nextReward } = useSelector(
    (state: AppState) => state.affiliate.user.bonuses.nextReward,
  )
  const referralRewards = referralFarming + referralTrading + teamFarming + teamTrading

  const rewardsCardBodyProps: RewardsCardBodyProps = {
    fetchStatus: bonusesFetchStatus,
    cashback,
    holderBonus,
    referralRewards,
  }

  const rewardsCardFooterProps: RewardsCardFooterProps = {
    nextReward,
    total,
    bonusesFetchStatus,
    nextRewardFetchStatus,
  }

  return (
    <CupertinoPanel openPanel={openPanel} onClosed={onClosed} panelKey="extraRewardsPane">
      <Flex className="flex-col">
        <Flex className="py-20 px-16">
          <RewardsCardBody {...rewardsCardBodyProps} />
        </Flex>
        <Flex className="py-20 px-16 bg-dark-gray-600">
          <RewardsCardFooter {...rewardsCardFooterProps} />
        </Flex>
      </Flex>
    </CupertinoPanel>
  )
}

export default ExtraRewardsPanel
